import { recordPath, recordRoute } from '@/shared/registry'

/** Where the user group pages live. */
export const userGroupsPath = '/site-management/user-groups'
export const createUserGroupPath = `${userGroupsPath}/new`
export const userGroupRoute = recordRoute('site-management', 'user-groups')
export const editUserGroupRoute = `${userGroupRoute}/edit`

/** A user group's details page. */
export function userGroupPath(id: string): string {
  return recordPath('site-management', 'user-groups', id)
}

/** The base of Group Details' slots (`detailsSlots`). */
export const userGroupDetailsSlot = 'site-management.user-group-details'

/** The API's user group endpoints. */
export const userGroupsApi = '/site-management/v1/user-groups'

export function userGroupApi(id: string): string {
  return `${userGroupsApi}/${encodeURIComponent(id)}`
}

/** A group's members: listed, added (POST) and taken out (DELETE) in bulk. */
export function userGroupMembersApi(id: string): string {
  return `${userGroupApi(id)}/members`
}

/** What each user group action needs. */
export const readUserGroupsPermission = 'site-management.user-groups.read'
export const writeUserGroupsPermission = 'site-management.user-groups.write'
export const deleteUserGroupsPermission = 'site-management.user-groups.delete'
export const userGroupMembersPermission = 'site-management.user-groups.members.write'

/** The most people one request adds or takes out, as the API allows. */
export const membersPerRequest = 1000
